import "react-lazy-load-image-component/src/effects/blur.css";

interface Item {
  id: string; // تغيير من number إلى string لدعم الـ key الفريد
  name: string;
  final_price: number;
  icon: string;
  category: number;
}

interface ItemsGridProps {
  items: Item[];
  emptyMessage: string;
  onItemClick?: (item: Item) => void;
  selectedIds?: string[];
}

const ProductItem = ({
  items,
  emptyMessage,
  onItemClick,
  selectedIds = [],
}: ItemsGridProps) => (
  <div className='px-2 sm:px-4 grid grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6 mb-24'>
    {items.length === 0 ? (
      <div className='col-span-full text-center py-12 text-gray-500 text-lg'>
        {emptyMessage}
      </div>
    ) : (
      items.map((item) => {
        const isSelected = selectedIds.includes(item.id);
        return (
          <div
            key={item.id}
            onClick={() => onItemClick?.(item)}
            className={` rounded-2xl border-2 p-3 sm:p-4 cursor-pointer transition-all duration-300 shadow-sm hover:shadow-lg transform hover:-translate-y-1 min-h-[140px] sm:min-h-[160px] flex flex-col justify-between
              ${
                isSelected
                  ? "border-red-500  shadow-red-100 bg-red-50"
                  : "border-gray-200 hover:border-red-300 bg-white"
              }
            `}
          >
            <div className='flex items-center gap-3 mb-4'>
              <div
                className={`w-14 h-14 sm:w-16 sm:h-16 rounded-xl flex items-center justify-center flex-shrink-0 transition-colors duration-300
                ${isSelected ? "bg-red-100" : "bg-gray-100"}
              `}
              >
                {item.icon ? (
                  <img
                    src={item.icon}
                    alt={item.name}
                    className='w-10 h-10 sm:w-12 sm:h-12 object-contain'
                  />
                ) : (
                  <div className='w-10 h-10 bg-red-500 rounded-lg flex items-center justify-center'>
                    <svg
                      width='24'
                      height='24'
                      viewBox='0 0 24 24'
                      fill='white'
                    >
                      <path d='M19 3h-1V1h-2v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V8h14v11zM7 10h5v5H7z' />
                    </svg>
                  </div>
                )}
              </div>

              {/* اسم المنتج */}
              <div className='flex-1'>
                <h3 className='text-sm sm:text-lg font-bold text-gray-800 leading-tight'>
                  {item.name}
                </h3>
              </div>
            </div>

            {/* السعر في الأسفل */}
            <div className='text-center mt-auto'>
              <span className='text-lg sm:text-xl font-bold text-red-600'>
                {item.final_price} ريال
              </span>
            </div>
          </div>
        );
      })
    )}
  </div>
);

export default ProductItem;
